import { render } from "./GenericPage.vue?vue&type=template&id=6afa4364&scoped=true"
import script from "./GenericPage.vue?vue&type=script&lang=js"
export * from "./GenericPage.vue?vue&type=script&lang=js"

import "./GenericPage.vue?vue&type=style&index=0&id=6afa4364&lang=scss"
import "./GenericPage.vue?vue&type=style&index=1&id=6afa4364&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afa4364"]])

export default __exports__